import axios from 'axios';

function downloadFile(filename, path) {
    const a = document.createElement('A');
    a.href = path;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

function downloadFileLink(filename, path) {
    axios({
        url: path,
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));

        downloadFile(filename, url);
    });
}

function downloadFileBase64(base64Data, fileName) {
    const linkSource = `data:application/pdf;base64,${base64Data}`;
    const a = document.createElement('a');
    a.href = linkSource;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export { downloadFile, downloadFileLink, downloadFileBase64 };
